// extracted by mini-css-extract-plugin
export default {"previewContainer":"src-views-common-components-SnapPreview-SnapPreview__previewContainer--dduy8"};